module.exports = __webpack_public_path__ + "img/伤者家中调查-文字信息@2x.26e548b2.png";